import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields';
import questions from './store/module/questions'

Vue.use(Vuex)


export default new Vuex.Store({
  modules: {
    patientQuestion: questions
  },
  state: {
    myTasks : [],
    myMessage : null,
    myMessageCount : 0,
    myHistory : 0,
    newTasks : null,
    myTasksNum : null,
    snackBarshow : false,
    snackBarType : "warning",
    snackBarmessage : "",
    isAuthorized : false,
    overlay : false,
    admins : [],
    user : {}
  },
  getters : {getField,isLoggedIn: state => state.isAuthorized,},
  mutations: {
    updateField
  },
  actions: {

  }
})
